import 'ui-core/widgets/ad-placeholder/js/ad-placeholder.js';
import 'ui-core/plugins/sticko/js/sticko';

UX.sticko.ads = function () {
    if (UX.sticko.$element.closest('.sticko-ads').length) {
        UX.sticko.$element.css({
            right: ($(document).width() - $('.container').width()) / 2 - 320,
            left: 'auto',
        });
    }

    let stickyAdElement = $('.sticko-ads').find('.sticko__md');

    let pageHeaderHeight = $('.pageHeader').outerHeight(),
        pagesNavHeight = 0,
        $pagesNav = $('.stickybar__wrapper');

    if ($pagesNav.length) {
        pagesNavHeight = $pagesNav.outerHeight();
    }

    let topPosition = pagesNavHeight + pageHeaderHeight;

    stickyAdElement.css('top', topPosition);
};
